import { useMemo } from 'react'

const getUA = () =>
  typeof navigator !== 'undefined' ? navigator.userAgent : ''

export const useIsMobileDevice = () =>
  useMemo(() => {
    const ua = getUA()
    const isIOS = /iphone|ipad|ipod/i.test(ua)
    const isAndroid = /android/i.test(ua)
    return {
      isMobileDevice: isIOS || isAndroid,
      isIOS,
      isAndroid
    }
  }, [])

export default useIsMobileDevice
